import { ActivatedRoute, RouterLink } from '@angular/router';
import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CommonModule } from '@angular/common';

import { HttpClient } from '@angular/common/http';
import { MatDivider } from '@angular/material/divider';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReactiveFormsModule } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { FooterComponent } from '../../Common/footer/footer.component';
import { HeaderComponent } from '../../Common/header/header.component';
import { FetchArrayDataService } from '../../services/fetch-array-data.service';
import { SeoService } from '../../services/seo.service';


@Component({
  selector: 'app-single-blog',
  templateUrl: './single-blog.component.html',
  styleUrls: ['./single-blog.component.scss'],
  imports: [CommonModule, RouterLink, ReactiveFormsModule, HeaderComponent, FooterComponent, MatDivider],
  standalone: true,
})
export class SingleBlogComponent implements OnInit {
  blogSlug: string | null = null;
  ArticleDetails: any | null = null;
  latestFive: any[] = [];
  blogCategories: any[] = [];
  storageUrl = environment.storageUrl;
  baseUrl = environment.baseUrl;
  domainUrl = environment.domainUrl;
  randomImageUrl = 'assets/images/fallback.webp';

  constructor(
    private arrayData: FetchArrayDataService,
    private snackBar: MatSnackBar,
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private seoService: SeoService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.blogSlug = params.get('id');
      if (this.blogSlug) this.FetchArticle();
    });

    this.FetchBlogCategories();
    this.fetchLatestFiveArticles();
  }

  FetchArticle(): void {
    if (!this.blogSlug) return;

    this.arrayData.fetchArticleDetails(this.blogSlug).subscribe({
      next: (res: any) => {
        this.ArticleDetails = res.data;
        const imageUrl = this.getImageUrl(this.ArticleDetails.featured_img_path);

        this.seoService.updateMetaTags({
          title: `${this.ArticleDetails.title} - Rohit Parihar`,
          description: this.ArticleDetails.subtitle || this.ArticleDetails.description || this.ArticleDetails.title,
          image: imageUrl,
          url: `${this.domainUrl}/blog/${this.blogSlug}`,
          type: 'article',
          keywords: this.ArticleDetails.keywords || this.ArticleDetails.title,
          author: this.ArticleDetails.author_name || 'Rohit Parihar'
        });

        this.randomImageUrl = imageUrl;
      },
      error: () => this.handleError('Unable to fetch article details.'),
    });
  }

  FetchAllArticles(categoryId?: number): void {
    const obj = {
      account_id: 1,
      category_id: categoryId ?? null,
    };

    this.http.post(`${environment.baseUrl}/latest_articles`, obj).subscribe({
      next: (res: any) => {
        if (categoryId) {
          this.ArticleDetails = res.data[0] || null;
          this.randomImageUrl = this.getImageUrl(
            this.ArticleDetails?.featured_img_path
          );
        }
      },
      error: () => this.handleError('Unable to fetch articles.'),
    });
  }

  FetchBlogCategories(): void {
    this.http.get(`${environment.baseUrl}/fetch_categories`).subscribe({
      next: (res: any) => {
        this.blogCategories = res.data;
      },
      error: () => this.handleError('Unable to fetch blog categories.'),
    });
  }

  fetchLatestFiveArticles(): void {
    this.http
      .post(`${environment.baseUrl}/latest_articles_five`, { account_id: 1 })
      .subscribe({
        next: (res: any) => {
          this.latestFive = res.data;
        },
        error: () => this.handleError('Unable to fetch the latest articles.'),
      });
  }

  private getImageUrl(path: string | undefined): string {
    return path ? `${this.storageUrl}/${path}` : 'assets/images/fallback.webp';
  }

  private handleError(message: string): void {
    console.error(message);
    if (isPlatformBrowser(this.platformId)) {
      this.snackBar.open(message, 'Close', { duration: 3000 });
    }
  }
}
